import { connect } from 'react-redux'

import { selectAverageResolutionTimeForEachDayGauge } from 'ducks/reports/gauges'

import { AreaChart } from 'ducks/reports/visualizations'

const staticSelect = {
  height: 300,
  scale: { y: 'duration' },
}
const select = (state, props) => ({
  ...staticSelect,
  gauge: selectAverageResolutionTimeForEachDayGauge(state, props),
})
export default connect(select)(AreaChart)
